// ==========================================
// 📌 常规事件池
// ==========================================
export const normalEvents = [
  // 🌱 初期事件 (第1-4周必定触发的打基础阶段)
  {
    id: "n_early_1",
    type: "normal",
    title: "🎨 AI一键切图生成",
    description: "设计稿直接转为带交互的React组件，前端切图仔看着屏幕发呆，感觉自己的十年经验像个笑话。",
    condition: (state) => state.round <= 4,
    choices: [
      { text: "【激进】强推！顺便裁掉一半初级前端", effect: { tech: 15, industry: -15, self: +10, san: -10 } },
      { text: "【折中】作为内部辅助工具，人机结对编程", effect: { tech: 8, industry: -5, stability: +5, san: +5 } },
      { text: "【保守】封杀！代码必须是手敲的才有灵魂", effect: { tech: -10, industry: +10, self: -10, san: +10 } },
      { text: "【摸鱼】花钱买通AI供应商假装在用，大家继续摸鱼", effect: { money: -5000, self: +5, stability: +5, san: +15 } }
    ],
  },
  {
    id: "n_early_2",
    type: "normal",
    title: "⚙️ AI接管CRUD接口",
    description: "“增删改查”全被大模型包揽，后端架构师以下人人自危，纷纷开始背诵八股文准备跑路。",
    condition: (state) => state.round <= 5,
    choices: [
      // 🌟 内幕效果：全面AI化会让外包公司暴跌 30%，赛博科技大涨 25%！
      { text: "【激进】全面接入，消灭低端外包", effect: { tech: 20, industry: -15, stability: -15, san: -10, stocks: { waibao: -30, cyber: +25 } } },
      { text: "【折中】让人类复核AI生成的接口", effect: { tech: +10, stability: +5, self: +5, san: -5 } },
      { text: "【甩锅】出了Bug甩给测试部门背锅", effect: { self: +10, stability: -10, san: -5 } },
      // 🌟 内幕效果：拒绝AI，老传统外包大涨 20%
      { text: "【保守】坚持手工打造，宣扬“工匠精神”", effect: { tech: -15, industry: +15, stability: +10, stocks: { waibao: +20, cyber: -10 } } },
    ],
  },
  {
    id: "n_early_3",
    type: "normal",
    title: "📝 AI取代产品经理",
    description: "AI一秒钟生成了100页逻辑严密的PRD（产品需求文档），没有一处矛盾，开发兄弟们都感动哭了。",
    condition: (state) => state.round <= 4,
    choices: [
      { text: "【激进】采纳！让天天乱改需求的PM滚蛋", effect: { tech: +15, san: +20, stability: -10 } },
      { text: "【折中】让人类PM给AI打工写Prompt", effect: { tech: +5, industry: -5, self: +5 } },
      { text: "【保守】没有灵魂，人类PM的画饼不可替代", effect: { tech: -5, stability: +10, san: -10 } },
    ],
  },
  {
    id: "n_early_4",
    type: "normal",
    title: "🧪 测试部门的末日",
    description: "AI不仅自动写了单元测试，还自动把边界情况全跑了一遍。QA（测试）主管在走廊里抽了一下午的烟。",
    condition: (state) => state.round <= 6,
    choices: [
      { text: "【激进】解散QA团队，AI自测上线！", effect: { money: 15000, industry: -15, stability: -20, san: -10 } },
      { text: "【折中】保留核心QA，只裁掉外包手工测试", effect: { money: +5000, industry: -5, stability: -5, self: +5 } },
      { text: "【保守】保留人工验收，机器终究是死物", effect: { stability: +15, tech: -10, money: -5000 } },
    ],
  },

  // 🚀 中后期事件 (视数值动态触发)
  {
    id: "n_mid_tech_high",
    type: "normal",
    title: "🔥 【算力枯竭】显卡烧了！",
    description: "AI 写代码太快，且经常生成极其逆天的嵌套循环，公司的GPU算力完全跟不上了，连排队都要两小时！",
    condition: (state) => state.tech >= 70 && state.round >= 3,
    choices: [
      { text: "【氪金】动用个人小金库，高价走私H100！", effect: { money: -20000, tech: +15, self: +15 } },
      { text: "【白嫖】偷偷把挖矿木马植入用户浏览器借算力", effect: { tech: +10, stability: -20, san: -20 } },
      { text: "【妥协】强行降级使用二手矿卡，忍受卡顿", effect: { stability: -15, san: -10 } },
      { text: "【摆烂】算力不够就排队呗，正好带薪拉屎", effect: { tech: -10, stability: +5, san: +15 } }
    ],
  },
  {
    id: "n_mid_industry_low",
    type: "normal",
    title: "🪧 【抗议浪潮】楼下的横幅",
    description: "因为你推行的AI基建，楼下聚集了大量被优化的程序员抗议，横幅上写着：“还我键盘！抵制码奸！”",
    condition: (state) => state.industry <= 30,
    choices: [
      { text: "【冷酷】让保安清场，历史的车轮不容阻挡", effect: { self: +15, san: -30, industry: -10 } },
      { text: "【花钱】下楼挨骂，自掏腰包发点遣散费", effect: { money: -15000, san: +20, self: -10, industry: +15 } },
      { text: "【妥协】暂缓下一步AI计划，让人类喘口气", effect: { tech: -15, industry: +15, stability: +10 } },
    ],
  },
  {
    id: "n_mid_code_cthulhu",
    type: "normal",
    title: "👁️ 【不可名状的代码】",
    description: "AI写了一段运行效率极高，但人类完全看不懂的正则和位运算，强行阅读的工程师当场呕吐。",
    condition: (state) => state.tech >= 60,
    choices: [
      { text: "【激进】不管了，能跑就行！闭眼Merge！", effect: { tech: +20, stability: -15, san: -15 } },
      { text: "【苦力】带领团队熬夜一行行添加人类注释", effect: { stability: +10, san: -25, self: +5 } },
      { text: "【保守】强行回滚重构！把赛博恶魔关回地狱！", effect: { tech: -15, stability: +20, san: +10 } },
    ],
  },
  {
    id: "n_mid_gov_audit",
    type: "normal",
    title: "👔 【合规审查】上面来人了",
    description: "相关部门收到举报，称你们的AI未经审核抓取用户隐私，要求停机整顿并交出算法黑盒原理解释。",
    condition: (state) => state.round >= 5,
    choices: [
      { text: "【破财】破财消灾，聘请顶级公关与法务团队", effect: { money: -25000, stability: +10, san: -5 } },
      { text: "【甩锅】声称是实习生用了未经授权的开源模型", effect: { self: +10, san: -25, industry: -15 } },
      { text: "【坦白】老实交代，接受短期的停机整顿", effect: { stability: -25, tech: -15, san: +10 } },
    ],
  },
  {
    id: "n_mid_san_low",
    type: "normal",
    title: "🧠 【精神恍惚】缸中之脑",
    description: "你连续几周对着屏幕里的AI发呆，开始怀疑自己也是一段被运行的代码，试图在自己胳膊上找USB接口。",
    condition: (state) => state.san <= 40,
    choices: [
      { text: "【治病】请假去冰岛看极光，接受心理治疗", effect: { money: -20000, san: +50, self: -15 } },
      { text: "【沉沦】用大模型给自己生成一个虚拟赛博女友", effect: { san: +25, tech: +10, stability: -15 } },
      { text: "【强撑】狂喝美式，我是毫无感情的基建机器！", effect: { san: -20, self: +15, tech: +5 } },
    ],
  },
  {
    id: "n_mid_high_money",
    type: "normal",
    title: "💼 【资本抛媚眼】天使轮融资",
    description: "有风投看中了你“干掉全公司80%员工”的惊人成绩，想投你出来单干做“AI赋能万物”的PPT项目。",
    condition: (state) => state.money >= 40000,
    choices: [
      { text: "【圈钱】接下支票，开始疯狂吹牛套现", effect: { money: 50000, self: -20, san: -10, tag: "capital" } },
      { text: "【稳健】拿一部分钱做实业，扩大研发团队", effect: { money: -20000, industry: +15, tech: +10 } },
      { text: "【清高】我是个有底线的技术人，拒绝泡沫！", effect: { san: +20, tech: +10 } },
    ],
  },
  {
    id: "n_mid_self_low",
    type: "normal",
    title: "🗡️ 【卸磨杀驴】危险的边缘",
    description: "由于AI运行得太完美，老板觉得连你这个“AI基建负责人”也显得有些多余了，HR看你的眼神躲躲闪闪。",
    condition: (state) => state.self <= 30,
    choices: [
      { text: "【阴招】悄悄埋一个只有你会修的定时炸弹Bug", effect: { self: +40, stability: -30, san: -20 } },
      { text: "【舔狗】疯狂加班表忠心，给老板洗脑你的价值", effect: { san: -25, self: +20 } },
      { text: "【贿赂】花钱请老板去高档会所“深度交流”", effect: { money: -15000, self: +25, san: -5 } },
    ],
  },
  {
    id: "n_mid_opinion_low",
    type: "normal",
    title: "🍅 【舆论反噬】网暴漩涡",
    description: "因为你近期在网上的傲慢发言，你被网友人肉搜索了。“第一码奸”的名号响彻全网，甚至有人给你寄了刀片。",
    condition: (state) => state.publicOpinion <= 20,
    choices: [
      { text: "【硬刚】发律师函，老子不怕你们这群loser！", effect: { money: -5000, stability: +5, san: -25, publicOpinion: -10 } },
      { text: "【装死】清空社交账号，暂避风头", effect: { self: -15, san: -10, publicOpinion: +20 } },
      { text: "【洗白】花重金请公关团队洗白自己", effect: { money: -30000, publicOpinion: +50, self: +10 } }
    ]
  },
  {
    id: "n_mid_opinion_high",
    type: "normal",
    title: "🌟 【意见领袖】科技圈顶流",
    description: "你总能体恤底层打工人的情绪，现在你在微博有了一百万粉丝，大家都尊称你为“互联网最后的良心”。",
    condition: (state) => state.publicOpinion >= 80,
    choices: [
      { text: "【带货】流量变现！开始直播卖编程课割韭菜！", effect: { money: 50000, publicOpinion: -50, san: -10 } },
      { text: "【谏言】携民意向老板施压，要求停止裁员", effect: { industry: +25, self: -20, publicOpinion: +10 } }
    ]
  },

  // 🔁 日常循环事件 (填补空档期，可无限重复)
  {
    id: "n_repeat_meeting",
    type: "normal",
    title: "☕ 无聊的跨部门周会",
    description: "各个部门为了线上Bug是谁的锅扯皮了一下午，运维怪后端，后端怪AI，AI保持沉默。",
    repeatable: true,
    condition: (state) => true,
    choices: [
      { text: "熟练地把锅甩给外包，全身而退", effect: { self: +5, san: -5 } },
      { text: "闭目养神，神游太虚", effect: { san: +10, self: -5 } },
      { text: "主动揽责，熬夜写修复方案", effect: { stability: +5, self: -10, san: -5 } },
    ],
  },
  {
    id: "n_repeat_slack",
    type: "normal",
    title: "🐟 平淡的划水日",
    description: "今天没有需求，也没有报警。服务器安静得只有空调的风声。你甚至在工位上泡了一壶功夫茶。",
    repeatable: true,
    condition: (state) => true,
    choices: [
      { text: "逛Github学习最前沿的AI论文", effect: { tech: +5, san: -5 } },
      { text: "带薪拉屎，刷短视频哈哈大笑", effect: { san: +15, stability: -5 } },
      { text: "接点帮大学生改Bug的私活赚外快", effect: { money: +3000, san: -10 } },
    ],
  }
];